import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { Redirect, matchPath } from 'react-router';
import format from 'date-fns/format';
import DateFnsUtils from '@date-io/date-fns';
import frLocale from 'date-fns/locale/fr';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { withTheme, MuiThemeProvider, createMuiTheme, withStyles } from '@material-ui/core';
import { EventEmitter, uiTheme as defaultTheme, Toastr } from 'data/common';
import Splashpage from 'scenes/Splashpage';
import { logOutUser } from 'data/user/actions';
import routes from '../../routes';
import environments from '../../environments';
import PACKAGE from '../../../../package.json';

class LocalizedUtils extends DateFnsUtils {
    getDatePickerHeaderText(date) {
        return format(date, 'd MMM yyyy', { locale: this.locale });
    }
}

class App extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        children: PropTypes.object.isRequired,
        logOutUser: PropTypes.func.isRequired,
        initialized: PropTypes.bool.isRequired
    };

    static childContextTypes = {
        changeTheme: PropTypes.func
    };

    redirectTo = null;
    constructor(props) {
        super(props);
        let { history } = this.props;
        if (!routes.hasIn([history.location.pathname])) {
            const redirect_from = environments.getEnvironments().find((route, path) => {
                return [`/${path}`, `/${path}/`].indexOf(history.location.pathname) !== -1;
            });
            if (redirect_from) {
                this.redirectTo = '/';
            }
        }
        this.state = {
            theme: createMuiTheme(defaultTheme)
        };
    }

    getChildContext() {
        return { changeTheme: this.changeTheme };
    }

    componentDidMount() {
        const eventEmitter = EventEmitter();
        eventEmitter.on('logOut', this._handleDisconnect);
        eventEmitter.on('error401', data => {
            if (data.error_code === 'TOKEN_EXPIRED' || data.error_code === 'USER_NOT_FOUND_BY_TOKEN') {
                Toastr.error(Translator.translate(`api.message.${data.error_code}`));
                this._handleDisconnect();
            }
        });
        eventEmitter.on('error400', () => {});
    }

    componentWillUnmount() {
        const eventEmitter = EventEmitter();
        eventEmitter.removeAllListeners();
    }

    changeTheme = otherTheme => {
        const { theme } = this.state;

        if (theme.id !== otherTheme.id) {
            this.setState({
                theme: otherTheme
            });
        }
    };

    _handleDisconnect = () => {
        const { logOutUser } = this.props;
        logOutUser();
        this.redirectTo = '/login';
        return this.forceUpdate();
    };

    render() {
        let { history, children, initialized, classes } = this.props;
        const { theme } = this.state;

        if (history.location.pathname !== '/login') {
            if (!localStorage.getItem('access_token')) return <Redirect to="/login" />;
            if (!initialized) return <Splashpage />;
        }
        return (
            <Fragment>
                <MuiPickersUtilsProvider utils={LocalizedUtils} locale={frLocale}>
                    <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
                </MuiPickersUtilsProvider>
                <div className={classes.version}>{PACKAGE.version}</div>
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        initialized: state.data.initialized
    };
}

const styles = () => ({
    version: {
        fontSize: '0.8em',
        position: 'fixed',
        right: 20,
        bottom: 10,
        color: 'rgb(255, 255, 255)',
        textShadow: '2px 2px 2px #495057',
        zIndex: 50
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators(Object.assign({}, { logOutUser }), dispatch)
    )(withStyles(styles, { withTheme: true })(App))
);



// WEBPACK FOOTER //
// ./layouts/App/index.js